export enum MapPrivacySelectInputField {
  Password = 'privacy_level.password',
}
